import styled from 'styled-components';

export const StyledRiskMatrixFullDisplay = styled.div`
  /* Constrain to the page content column. The matrix grid has a fixed intrinsic
     width (fixed-width cells), so without a width bound the overflow:auto box
     collapses and the grid escapes to the right of the page. Cap to 100% and let
     the grid scroll horizontally within its own box instead. */
  width: 100%;
  max-width: 100%;
  max-height: var(--page-max-height);
  overflow: auto;
  /* The rotated "Likelihood" axis label is positioned at left:-40px relative to the
     matrix; reserve a left gutter so overflow:auto doesn't clip it. */
  padding-left: 48px;
  box-sizing: border-box;
`;
